export interface CustomOption
{
    customOption:boolean;
    id: string;
    label: string;
}

export const extactValues = (values: (string | CustomOption)[]) => {
    return values.map(tag => {
        if(typeof tag === 'string')
            return tag;
        if(typeof tag === 'object' && tag.customOption)
            return tag.label;
        
        throw new Error('unexpected tag type');
    });
}


// WEBPACK FOOTER //
// ./src/app/utils/TypeAhead.ts